import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import PageLoader from "../../../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";
import { selectListItems } from "../../../../../../redux/library/selector";
import { selectSmsCampaignsListItems } from "../../../../../../redux/sms-campaigns/selector";
import { smsCampaigns } from "../../../../../../redux/sms-campaigns/action";

const SMSCampaigns = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const libraryData = useSelector(selectListItems)
  const itemsData = useSelector(selectSmsCampaignsListItems)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name', isEdit: true },
      { field: 'FrequencyId', headerName: 'Frequency Type', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library: libraryData?.result?.CampaignFrequency }, sortable: true, filter: false },
      { field: 'StartDate', headerName: 'Start Date', isDateValueFormat: true },
      { field: 'EndDate', headerName: 'End Date', isDateValueFormat: true }

    ]);
  }

  const handleAdd = () => {
    navigate(`/agencies/promotions/marketing/sms/campaigns2/${0}`)
  }

  const handleEdit = (data: any) => {
    navigate(`/agencies/promotions/marketing/sms/campaigns2/${data?.Id}`)
  }

  const handleDelete = (data: any) => {
    dispatch(smsCampaigns.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/campaign/sms-campaigns/delete`,
      entity: 'smsCampaigns',
      jsonData: {
        Records: [
          {
            Id: data?.Id
          }
        ]
      }
    })).then(async () => {
      await dispatch(smsCampaigns.resetAction({ actionType: 'list' }));
      await dispatch(smsCampaigns.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/campaign/sms-campaigns/list`, entity: 'emailCampaigns', jsonData: {

          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",

        }
      }))
    });
  }

  const additionButtons: any = [
    {
      name: 'Add New SMS Campaign',
      callback: () => handleAdd(),
    }
  ];



  const fetchSMSCampaigns = async () => {
    await dispatch(smsCampaigns.resetAction({ actionType: 'list' }));
    await dispatch(smsCampaigns.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/campaign/sms-campaigns/list`, entity: 'smsCampaigns', jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",

      }
    }))

  }
  useEffect(() => {

    createColumnDefs()
    // fetchCampaigns()
    fetchSMSCampaigns();
  }, [pageData, pageSize])

  return (
    <>
      {itemsData?.isLoading ?
        <PageLoader /> :
        <Table
          columnData={columnDefs}
          rowData={itemsData?.result?.items}
          setPageData={setPageData}
          setPageSize={setPageSize}
          paginationData={itemsData?.result?.pagination}
          onEdit={handleEdit}
          onDelete={handleDelete}
          additionButtons={additionButtons}
          headingName="SMS Campaigns"
        />

      }
    </>
  );
};

export default SMSCampaigns;


